import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";

@Component({
	selector: "legacy-label",
	standalone: true,
	imports: [CoreModule],
	templateUrl: "./legacy-label.component.html",
	styleUrl: "./legacy-label.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegacyLabelComponent {}
